const config = () => ({
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json',
    'CSRF-Token': window.csrfToken
  }
});

export default config;